import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import {
  Row, Col, Input, Radio, Table, Button,
  Collapse, Spin, Icon,
} from 'antd';
import AppDatasBody from '../util/AppDatasBody';
import CSBrowser from '../public/cs-browser';
import AppApplyModal from './AppApplyModal';
const Panel = Collapse.Panel;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
const store = ['appOrderStore', 'commonStore'];
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'order-app',
  }
  constructor(props) {
    super(props);
    this.state = {
      activeKey: 'customerListCol0',
      visible: false,
    }
  }
  componentDidMount() {
    const { appOrderStore: { init, getCustomer } } = this.props;
    init();
    getCustomer({ id: -1 });
  }
  view = (record) => {
    const { commonStore: { view } } = this.props;
    // view(record);
    // window.open('http://203.110.166.60:8088/login/login4wf.jsp?userid=1&gopage=' +
    //   `/cloudstore/system/index.jsp#/${record.s_number}/set`);
  }
  getExpandedRowRender = (record) => {
    const { prefixCls } = this.props;
    return (
      <Row>
        <Col className={`${prefixCls}-body-table-detail`} span={6}><span>申请人：</span>{record.m_name}</Col>
        <Col className={`${prefixCls}-body-table-detail`} span={6}><span>授权用户：</span>{record.c_name}</Col>
        <Col className={`${prefixCls}-body-table-detail`} span={6}><span>申请时间：</span>{record.tm_createtime}</Col>
        <Col className={`${prefixCls}-body-table-detail`} span={6}><span>申请人公司：</span>{record.m_comname}</Col>
        <Col className={`${prefixCls}-body-table-detail`} span={6}><span>申请人分部：</span>{record.m_branch}</Col>
        <Col className={`${prefixCls}-body-table-detail`} span={6}><span>申请人部门：</span>{record.m_department}</Col>
        <Col className={`${prefixCls}-body-table-detail`} span={12}><span>LICENSE：</span>{record.m_license}</Col>
      </Row>
    );
  }
  onSearch = (params = {}) => {
    const { appOrderStore: { setSearchParams, filterCustomerList } } = this.props;
    setSearchParams(params);
    filterCustomerList();
  }
  onChange = (pageNum, pageSize) => {
    const { appOrderStore: { setMobxState, getCustomer } } = this.props;
    setMobxState({ pageNum, pageSize });
    getCustomer({ id: -2 });
  }
  render() {
    const { activeKey, visible } = this.state;
    const { prefixCls, location,
      appOrderStore: {
        loading, selectedOrderKey, loadingRes, setCustomerList, getApply,
        loadingApply, setSearchParams, setMobxState, customerCount, pageSize, pageNum,
      },
    } = this.props;
    let { appOrderStore: { orderList, customerList, appApplyDatas, searchParams, customerListData, selectedRowKeys, selectedRows } } = this.props;
    orderList = toJS(orderList);
    customerList = toJS(customerList);
    appApplyDatas = toJS(appApplyDatas);
    searchParams = toJS(searchParams);
    customerListData = toJS(customerListData);
    selectedRows = toJS(selectedRows);
    const browserColumns = [
      { title: '服务器', dataIndex: 'c_name', key: 'c_name', },
    ];
    const columns = [
      { title: '订单号', dataIndex: 'tm_oid', key: 'tm_oid' },
      { title: '应用名称', dataIndex: 's_name', key: 's_name' },
      { title: '应用编码', dataIndex: 's_number', key: 's_number' },
      { title: '申请日期', dataIndex: 'tm_createtime', key: 'tm_createtime', render: (text) => text.split(' ')[0] },
      { title: '申请类型', dataIndex: 'tm_type', key: 'tm_type' },
      {
        title: '订单状态', dataIndex: 'tm_status', key: 'tm_status',
        render: (text) => text === '0' ? '驳回'
          : text === '1' ? '申请'
            : text === '2' ? '通过'
              : text === '5' ? '审核' : '',
      },
      { title: '版本', dataIndex: 'tm_beta', key: 'tm_beta', render: (text) => text === '0' ? 'alpha' : 'beta' },
      {
        title: '操作', dataIndex: 'status', key: 'status', width: 110, render: (text, record) => {
          const needView = record.s_fb !== '2';
          return (
            <div>
              { needView && (<span className='list-table-btn' style={{cursor: 'not-allowed'}} onClick={() => this.view(record)}>预览</span>) }
              <span className='list-table-btn' style={record.tm_status !== '2' ? { color: '#999' } : {}} onClick={() => {
                if (record.tm_status === '2') {
                  getApply(record.s_number, record.s_name, record.tm_id);
                  this.setState({ visible: true });
                }
              }}>获取</span>
            </div>
          )
        }
      },
    ];
    return (
      <div className={prefixCls}>
        <AppDatasBody location={location}>
          <div className={`cs-search-mylist ${prefixCls}-list`}>
            <div className={`${prefixCls}-header`}>
              <Row className={`${prefixCls}-header-row`}>
                <Col span={2}><span className={`${prefixCls}-header-label text-elli`} title="应用名称：">应用名称：</span></Col>
                <Col span={6}>
                  <Input value={searchParams.name} onChange={(e) => {
                    setSearchParams({ name: e.target.value });
                  }} onPressEnter = {(e) => this.onSearch({ name: e.target.value })}/>
                </Col>
                <Col span={2}><span className={`${prefixCls}-header-label text-elli`} title="申请类型：">申请类型：</span></Col>
                <Col span={6}>
                  <RadioGroup value={searchParams.tmType} onChange={(e) => this.onSearch({ tmType: e.target.value })}>
                    <RadioButton value="all">全部</RadioButton>
                    <RadioButton value="试用">试用</RadioButton>
                    <RadioButton value="永久">永久</RadioButton>
                  </RadioGroup>
                </Col>
                <Col span={2}><span className={`${prefixCls}-header-label text-elli`} title="版本：">版本：</span></Col>
                <Col span={6}>
                  <RadioGroup value={searchParams.beta} onChange={(e) => this.onSearch({ beta: e.target.value })}>
                    <RadioButton value="all">全部</RadioButton>
                    <RadioButton value="0">alpha</RadioButton>
                    <RadioButton value="1">beta</RadioButton>
                  </RadioGroup>
                </Col>
              </Row>
              <Row className={`${prefixCls}-header-row`}>
                <Col span={2}><span className={`${prefixCls}-header-label text-elli`} title="订单状态：">订单状态：</span></Col>
                <Col span={6}>
                  <RadioGroup value={searchParams.tmStatus} onChange={(e) => this.onSearch({ tmStatus: e.target.value })}>
                    <RadioButton value="all">全部</RadioButton>
                    <RadioButton value="2">通过</RadioButton>
                    <RadioButton value="0">驳回</RadioButton>
                    <RadioButton value="1">申请</RadioButton>
                  </RadioGroup>
                </Col>
              </Row>
            </div>
            <div className={`${prefixCls}-body`}>
              <Spin spinning={loadingRes}>
                <Button
                  className={`${prefixCls}-body-btn`}
                  disabled={selectedRowKeys.length === 0}
                  onClick={() => {
                    const sNumber = selectedRows.map(v => v.s_number);
                    const sName = selectedRows.map(v => v.s_name);
                    const tmId = selectedRows.map(v => v.tm_id);
                    getApply(sNumber.join(), sName.join(), tmId.join());
                    this.setState({ visible: true });
                  }}
                >批量获取</Button>
                {
                  customerListData && customerListData.length > 0 ? (
                    <Table
                      rowKey="tm_oid"
                      dataSource={customerListData}
                      columns={columns}
                      expandedRowRender={this.getExpandedRowRender}
                      pagination={{
                        showTotal: (total) => `共${total}条`,
                        total: customerCount,
                        pageSize,
                        current: pageNum,
                        onChange: this.onChange,
                        onShowSizeChange: this.onChange,
                      }}
                      className={`list-table order-list-table`}
                      locale={{
                        emptyText:
                          <div style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.43)', textAlign: 'center' }}>
                            <Icon type="frown-o" />
                            <span style={{ marginLeft: 4 }}>暂无数据</span>
                          </div>
                      }}
                      rowSelection={
                        {
                          type: 'checkbox',
                          selectedRowKeys: selectedRowKeys || [],
                          onChange: (selectedRowKeys, selectedRows) => {
                            setMobxState({ selectedRowKeys, selectedRows });
                          },
                          getCheckboxProps: (record) => {
                            return {
                              disabled: record.tm_status !== '2',
                            }
                          }
                        }
                      }
                    />
                  ) : (
                    <div className='order-no-data'>
                      <div className='icon-Cloud-No-data'/>
                      <div>暂无数据</div>
                    </div>
                  )
                }
              </Spin>
            </div>
          </div>
          <AppApplyModal
            datas={appApplyDatas}
            visible={visible}
            loading={loadingApply}
            onCancel={() => this.setState({ visible: false })}
          />
        </AppDatasBody>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/order/AppOrder.js